import { computed } from 'vue';
import { useStore } from 'vuex';
import { parseJwt } from '@hems/util/src/helper/authHelper';
export const useHomeownerInfo = () => {
    const store = useStore();
    const idToken = computed(() => store.state.user.idToken || '');
    const idTokenJwtObject = computed(() => parseJwt(idToken.value));
    const siteId = computed(() => Number(idTokenJwtObject.value?.site_id) || null);
    const homeOwnerInfo = computed(() => {
        return {
            siteId: idTokenJwtObject.value?.site_id || '',
            id: idTokenJwtObject.value?.preferred_username || '',
            firstName: idTokenJwtObject.value?.given_name || '',
            lastName: idTokenJwtObject.value?.family_name || '',
            displayName: idTokenJwtObject.value?.name || '',
            telephone: idTokenJwtObject.value?.telephone || '',
            region: idTokenJwtObject.value?.region || '',
        };
    });
    return {
        siteId,
        idTokenJwtObject,
        homeOwnerInfo,
    };
};
